// extracted by mini-css-extract-plugin
export var table = "_yh-0";